import React from 'react';

import MetricCacheBanner from './MetricCacheBanner';

const DebugOverlays = () => {
  return <MetricCacheBanner />;
};

export default DebugOverlays;
